import React, { useContext } from 'react';
import { EDIT_SCHEMA_MODE } from '../../../../constants';
import { SchemaDisplayContext } from '../../../context';
import ConnectionSocketOut from '../../ConnectionSocketOut';
import DeleteTrigger from '../../DeleteTrigger';
import EditTrigger from '../../EditTrigger';
import UnchainMarker from '../../UnchainMarker';
import ViewTrigger from '../../ViewTrigger';
import { useBaseStyles } from '../style';

function EditControls(props) {
  const styles = useBaseStyles();
  const { width } = props;
  const { schema: { mode }, plaza: { isActive, locked } } = useContext(SchemaDisplayContext);

  return (mode === EDIT_SCHEMA_MODE && isActive) ? (
    <foreignObject
      x={1}
      y={-30}
      width={width - 2}
      height={30}
    >
      <div className={styles.controls}>
        <div />
        {
          !locked && (
            <ConnectionSocketOut {...props} className="block-node" />
          )
        }

        <div
          className={styles.btns}
          draggable={false}
        >
          {
            !locked && (
              <>
                <UnchainMarker {...props} />
                <EditTrigger {...props} />
                <DeleteTrigger {...props} />
              </>
            )
          }
          {
            locked && (
              <ViewTrigger {...props} />
            )
          }
        </div>
      </div>
    </foreignObject>
  ) : null;
}

export default EditControls;
